import { render } from "./MoreTeacherDetails.vue?vue&type=template&id=8f51f308&scoped=true"
import script from "./MoreTeacherDetails.vue?vue&type=script&lang=js"
export * from "./MoreTeacherDetails.vue?vue&type=script&lang=js"

import "./MoreTeacherDetails.vue?vue&type=style&index=0&id=8f51f308&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f51f308"]])

export default __exports__